import { fetchSourceById, fetchSourceByLink, } from '#pplx/frontend/apps/ask/sources/hooks/internal/fetchSourceById.js';
import { getSourceFromCache } from '#pplx/frontend/apps/ask/sources/hooks/internal/getSourceFromCache.js';
import { isSourceAllowed, isSourceConnected, } from '#pplx/frontend/apps/ask/sources/hooks/sourceStatusPredicates.js';
/**
 * Fetches a source by ID, checking the React Query cache first and falling back
 * to the API. Returns the source along with its allowed/connected status.
 *
 * This is the shared query function used by both `useApiSource` (via React Query)
 * and imperative callers that need source status outside of a hook context.
 */
export async function fetchSource({ queryClient, sourceId, reason, bypassCache = false, resolveLink = false, }) {
    const cached = bypassCache || resolveLink ? null : getSourceFromCache(queryClient, sourceId);
    const source = resolveLink
        ? await fetchSourceByLink(sourceId, reason)
        : (cached ?? (await fetchSourceById(sourceId, reason)));
    return {
        source,
        isAllowed: isSourceAllowed(source),
        isConnected: isSourceConnected(source),
    };
}
//# sourceMappingURL=fetchSource.js.map